import {css} from "@emotion/react";
import React from 'react';
import {cssArray, CSSType} from "../../utils";
import {grid} from "./styles";

export interface GridProps {
    inverted?: boolean;
    lsize?: string;
    msize?: string;
    rsize?: string;
    contentCss?: CSSType;
}


export const TriGrid: React.FC<GridProps> = ({
    contentCss: _css,
    children,
    inverted,
    lsize = "1fr",
    msize = "1fr",
    rsize = "1fr",
}) => {
    const strSize = [lsize, msize, rsize];
    return (
        <div css={[grid, css({
            gridTemplateColumns: (inverted ? strSize.reverse() : strSize).join(' ')
        }), ...cssArray(_css)]}>
            {children}
        </div>
    );
};